/* unplugin-vue-components disabled */import script from "./imagetext.vue?vue&type=script&setup=true&lang=ts"
export * from "./imagetext.vue?vue&type=script&setup=true&lang=ts"

import "./imagetext.vue?vue&type=style&index=0&id=358f4e7b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358f4e7b"]])

export default __exports__